
export const INTERACTIONMODE = {
    DEFAULT: 'DEFAULT',
    CONVERSATIONMODE: 'CONVERSATION',
    COMPOSERMODE:'COMPOSER',
    OPTIMIZERMODE: 'OPTIMIZER',
}

export const INTERACTOINWINDOWTABS = {
    AICONVERSATION: 'AI Conversation',
    AICOMPOSER: 'AI Composer',
    AIOPTIMIZER: 'AI Optimizer',
}

export const INTERACTIONSPEAKER= {
    AI: 'AI',
    USER: 'USER',
}

export const CAPTIONS = {
    INTERACTIONINPUTCAPTIONS: {
        CONVERSATIONMODE: 'Have a chat with AI. Try to include your new words.',
        COMPOSERMODE: 'Select any words in the pool and let AI compose a paragragh including them.',
        OPTIMIZERMODE: 'Write your paragragh and let AI check it.',
    },

    INFOS: {
        CONVERSATIONMODE: 'Have a chat with AI. Try to include your new words.',
        COMPOSERMODE: 'Select any words in the pool and let AI compose a paragragh including them.',
        OPTIMIZERMODE: 'Write your paragragh and let AI check it.',
    }
}

export const PROFILEIAMGESIZE = {
    X_LARGE: 'x-large',
    LARGE: 'large',
    NORMAL: 'normal',
    SMALL: 'small',
    X_SMALL: 'x-small',
}

export const GAMEPLAY = {
    HOST: 'host',
    GUEST: 'guest',
}